<div class="splash-screen no-visitor-monitor">
  <div class="circle-with-exclamation-mark">
    <svg-icon icon="circle-with-exclamation-mark"></svg-icon>
  </div>

  <div class="instructions">
    <div>{{ 'bcAssistedBrowsingPanel.noVisitorMonitor' | translate }}</div>
  </div>
</div>
